import { Link } from "react-router-dom";
import { brandingConfig } from "../../config/branding";

export default function ContactSupportPage() {
  return (
    <div className="bg-gray-50 text-gray-800 font-sans pt-20 min-h-screen">
      <section className="bg-gradient-to-r  from-indigo-700 via-purple-700 to-indigo-800 py-20 text-white text-center px-6">
        <h1 className="text-4xl font-bold mb-4">Contact Support</h1>
        <p className="text-lg max-w-2xl mx-auto">
          We're here to help you get the most out of {brandingConfig.siteTitle}.
          Reach out any time — our team is standing by.
        </p>
      </section>

      <section className="py-16 px-6 max-w-3xl mx-auto text-center">
        <div className="bg-white border border-gray-200 rounded-xl shadow p-8">
          <h2 className="text-2xl font-semibold text-indigo-700 mb-4">
            Email Us
          </h2>
          <p className="text-gray-600 mb-6">
            Send us a message at{" "}
            <a
              href="mailto:hello@startupsmartup.com"
              className="text-indigo-600 underline"
            >
              hello@startupsmartup.com
            </a>
            . We'll get back to you as soon as we can!
          </p>
          <h2 className="text-2xl font-semibold text-indigo-700 mb-4">
            Live Chat
          </h2>
          <p className="text-gray-600">
            Need immediate help? Try our{" "}
            <Link to="/support/chat" className="text-indigo-600 underline">
              Live Chat
            </Link>{" "}
            during school hours (8am–5pm CST).
          </p>
        </div>
      </section>

      <section className="text-center pb-16">
        <Link
          to="/support"
          className="inline-block bg-indigo-600 text-white px-6 py-3 rounded-lg shadow hover:bg-indigo-700 transition font-medium"
        >
          Back to Support Page
        </Link>
      </section>
    </div>
  );
}
